import React from "react";

const Archive = ({
  color = "#193243",
  width = "20",
  height = "20",
  strokeWidth = "1.75",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 44 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3186_31)">
        <path
          d="M39.875 3.98755H4.125C3.3 3.98755 2.75 4.53755 2.75 5.36255V13.2001C2.75 14.0251 3.3 14.5751 4.125 14.5751H5.3625V38.5001C5.3625 39.3251 5.9125 39.8751 6.7375 39.8751H37.2625C38.0875 39.8751 38.6375 39.3251 38.6375 38.5001V14.5751H39.875C40.7 14.5751 41.25 14.0251 41.25 13.2001V5.36255C41.25 4.67505 40.7 3.98755 39.875 3.98755ZM35.8875 37.2626H8.1125V14.5751H35.8875V37.2626ZM38.5 11.8251H5.5V6.73755H38.5V11.8251Z"
          fill={color}
        />
      </g>
      <path
        d="M22.4344 28.1343L28.7444 21.7938C29.217 21.3189 29.2152 20.5507 28.7402 20.078C28.2653 19.6053 27.4972 19.6072 27.0245 20.0821L22.7888 24.3383V1.21323C22.7888 0.543165 22.2457 0 21.5756 0C20.9055 0 20.3624 0.543165 20.3624 1.21323V24.3383L16.1267 20.0821C15.654 19.6072 14.8859 19.6054 14.411 20.0781C13.9359 20.5508 13.9343 21.319 14.4068 21.7939L20.7157 28.1333C21.1899 28.6084 21.9617 28.608 22.4344 28.1343Z"
        fill={color}
      />
      <defs>
        <clipPath id="clip0_3186_31">
          <rect
            width="44"
            height="44"
            fill="white"
            transform="translate(0 0)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Archive;
